import { addDashIfZero, roundUpToTwoDecimalPlaces, } from "@domains/utils/numberMethods";
import { getDateInFormat } from "@domains/utils/reportDates";
export function pnlResponseMapper(pnLReportData) {
    const initial = {
        pnLDetails: [],
    };
    let pnLDetailsObj = { pnLDetails: [] };
    let pnLSummary = {
        totalPnl: "0",
        totalPnlChangePercent: "0",
        realisedPnl: "0",
        realisedPnlChangePercent: "0",
        unrealisedPnl: "0",
        unrealisedPnlChangePercent: "0",
        closePriceDate: "",
        totalMarketValue: "0",
        totalClosingCostValue: "0",
        totalSellCostValue: "0",
        totalSellValue: "0",
        totalInvestment: "0",
        daysPnLChange: "0",
        daysPnLChangePercent: "0",
        editableCount: 0,
    };
    let pnlDataFlags = { bodProcessInfoMessage: "", isBodEnabled: false };
    let editableCount = 0;
    if (pnLReportData) {
        pnLDetailsObj = pnLReportData.pnLDetails.reduce((acc, pnlReportRecord) => {
            let pnlFilterFlags = pnlReportRecord.filterFlags;
            if (pnlFilterFlags.editable)
                editableCount++;
            acc.pnLDetails.push(Object.assign(Object.assign({}, pnlReportRecord), { totalPnLChangePercent: roundUpToTwoDecimalPlaces(Number(pnlReportRecord.totalPnLChangePercent)), edelweissProductShortCode: pnlReportRecord === null || pnlReportRecord === void 0 ? void 0 : pnlReportRecord.edelweissProductShortCode, edelweissProduct: pnlReportRecord.edelweissProduct, editable: pnlFilterFlags.editable, realisedPnl: pnlFilterFlags.realisedPnl, unrealisedPnl: pnlFilterFlags.unrealisedPnl, profit: pnlFilterFlags.profit, loss: pnlFilterFlags.loss, isRealisedPnL: Number(pnlReportRecord.realisedQuantity) !== 0 ? true : false, isUnrealisedPnL: Number(pnlReportRecord.unrealisedBuyQuantity) !== 0 ||
                    Number(pnlReportRecord.unrealisedSellQuantity) !== 0
                    ? true
                    : false, unrealisedPnL: addDashIfZero(Number(roundUpToTwoDecimalPlaces(Number(pnlReportRecord.unrealisedPnL)))), realisedPnL: addDashIfZero(Number(roundUpToTwoDecimalPlaces(Number(pnlReportRecord.realisedPnL)))), totalPnL: roundUpToTwoDecimalPlaces(Number(pnlReportRecord.totalPnL)), marketValue: roundUpToTwoDecimalPlaces(Number(pnlReportRecord.marketValue)), investmentValue: roundUpToTwoDecimalPlaces(Number(pnlReportRecord.investmentValue)), unrealisedBuyValue: roundUpToTwoDecimalPlaces(Number(pnlReportRecord.unrealisedBuyValue)), realisedAvgBuyPrice: roundUpToTwoDecimalPlaces(Number(pnlReportRecord.realisedAvgBuyPrice)), realisedAvgSellPrice: roundUpToTwoDecimalPlaces(Number(pnlReportRecord.realisedAvgSellPrice)), displayName: pnlReportRecord.quote.displayName, quote: pnlReportRecord.quote, unrealisedSellQuantity: roundUpToTwoDecimalPlaces(Number(pnlReportRecord.unrealisedSellQuantity)), unrealisedSellValue: roundUpToTwoDecimalPlaces(Number(pnlReportRecord.unrealisedSellValue)), unrealisedAvgSellPrice: roundUpToTwoDecimalPlaces(Number(pnlReportRecord.unrealisedAvgSellPrice)), corpAction: pnlReportRecord.corpAction, corpActionType: pnlReportRecord.corpActionType, corpActionDesc: pnlReportRecord.corpActionDesc, expiryDate: getDateInFormat(pnlReportRecord.expiryDate, "DD-MMM-YYYY"), expiryMonth: getDateInFormat(pnlReportRecord.expiryDate, "MMM"), underlyingAsset: pnlReportRecord.underlyingAsset, optionType: pnlReportRecord.optionType, strikePrice: pnlReportRecord.strikePrice, instrumentType: pnlReportRecord.instrumentType, dayChange: pnlReportRecord.dayChange.toString(), news: pnlReportRecord.news, research: pnlReportRecord.research, exchange: pnlReportRecord.exchange, edelweissTabShortCode: pnlReportRecord.edelweissTabShortCode, shortTermQuantity: pnlReportRecord.shortTermQuantity, edelweissAsset: pnlReportRecord.edelweissAsset, tenure: pnlReportRecord.tenure, coupon: pnlReportRecord.coupon, rating: pnlReportRecord.rating, riskCategory: pnlReportRecord.riskCategory, yields: pnlReportRecord.yields, maturityDate: pnlReportRecord.maturityDate, interestFrequency: pnlReportRecord.interestFrequency, futureInterestEarning: pnlReportRecord.futureInterestEarning, faceValue: pnlReportRecord.faceValue, aum: pnlReportRecord.aum, dividendIncome: pnlReportRecord.dividendIncome, absoluteReturn: pnlReportRecord.absoluteReturn, interestPaid: pnlReportRecord.interestPaid, interestDue: pnlReportRecord.interestDue, freeQnty: pnlReportRecord.freeQnty, lockInQnty: pnlReportRecord.lockInQnty, schemeType: pnlReportRecord.schemeType, folioNumber: pnlReportRecord.folioNumber, holdingType: pnlReportRecord.holdingType, benchmark: pnlReportRecord.benchmark, category: pnlReportRecord.category, issuerName: pnlReportRecord.issuerName, status: pnlReportRecord.status, series: pnlReportRecord.series, lockInFlag: pnlReportRecord.lockInFlag }));
            pnlFilterFlags = null;
            return acc;
        }, initial);
        pnLSummary = Object.assign(Object.assign({}, pnLReportData.pnLSummary), { editableCount: editableCount });
        pnlDataFlags = {
            isBodEnabled: !!(pnLReportData === null || pnLReportData === void 0 ? void 0 : pnLReportData.isBodEnabled), bodProcessInfoMessage: pnLReportData === null || pnLReportData === void 0 ? void 0 : pnLReportData.bodProcessInfoMessage
        };
    }
    return {
        pnLSummary: pnLSummary,
        pnLDetails: pnLDetailsObj === null || pnLDetailsObj === void 0 ? void 0 : pnLDetailsObj.pnLDetails, pnlDataFlags
    };
}
export function pnlTransactionResponseMapper(pnLReportData) {
    const initial = {
        pnLTransactionDetails: [],
    };
    let pnLDetailsObj = { pnLTransactionDetails: [] };
    if (pnLReportData) {
        pnLDetailsObj = pnLReportData.pnLTransactionDetails.reduce((acc, pnlReportRecord) => {
            let pnlFilterFlags = pnlReportRecord.filterFlags;
            // delete pnlReportRecord.filterFlags;
            acc.pnLTransactionDetails.push(Object.assign(Object.assign({}, pnlReportRecord), { editable: pnlFilterFlags.editable }));
            pnlFilterFlags = null;
            return acc;
        }, initial);
    }
    else {
        pnLDetailsObj = initial;
    }
    return {
        pnl: pnLReportData ? pnLReportData.pnl : null,
        editableTransactionCount: pnLReportData
            ? pnLReportData.editableTransactionCount
            : 0,
        pnLTransactionDetails: pnLDetailsObj.pnLTransactionDetails,
    };
}
export const pnlBothTransactionResMapper = (pnLReportData) => {
    if (pnLReportData && pnLReportData.transactionList.length > 0) {
        let editableCount = 0;
        const transactionData = pnLReportData.transactionList.map((x) => {
            if (x.editFlag) {
                editableCount++;
            }
            return {
                action: x.action,
                brokerage: x.brokerage,
                editFlag: x.editFlag,
                filterFlags: x.filterFlags,
                otherCharge: x.other,
                price: x.transactionPrice,
                priceEditable: x.priceEditable,
                quantity: x.quantity,
                scripIdentifier: x.scripIdentifier,
                sebiFees: x.sebiTax,
                serviceTaxGst: x.stax_GST,
                splitAllowed: x.splitAllowed,
                stampDuty: x.stampDutyCharges,
                stt: x.stt,
                transactionCharge: x.transactionCharge,
                transactionChargeTax: x.tstax,
                transactionDate: x.transactionDate,
                transactionId: x.tranId,
                transactionType: x.txnType,
                editable: x.filterFlags.editable,
                cumulativeQuantity: x.cumulativeQuantity,
                netCharges: x.netCharges,
                daysPendingLongTerm: x.daysPendingLongTerm,
                exchangeName: x.exchangeName,
            };
        });
        return {
            pnl: "",
            editableTransactionCount: editableCount,
            pnLTransactionDetails: transactionData,
        };
    }
    else {
        return {
            pnl: "",
            editableTransactionCount: 0,
            pnLTransactionDetails: [],
        };
    }
};
export const pnlOriginalTxnMapper = (resp) => {
    if (resp) {
        return resp.map((x) => {
            return {
                accountCode: x.accountCode,
                accountID: x.accountID,
                action: x.action,
                brokerage: x.brokerage,
                editFlag: x.editFlag,
                exchangeName: x.exchangeName,
                isin: x.isin,
                other: x.other,
                quantity: x.quantity,
                sebiTax: x.sebiTax,
                security: x.security,
                stampDutyCharges: x.stampDutyCharges,
                stax_GST: x.stax_GST,
                stt: x.stt,
                tranId: x.tranId,
                transactionCharge: x.transactionCharge,
                transactionDate: x.transactionDate,
                transactionPrice: x.transactionPrice,
                tstax: x.tstax,
                txnType: x.txnType,
                priceEditable: x.priceEditable,
                splitAllowed: x.splitAllowed,
                filterFlags: {
                    editable: x.filterFlags.editable,
                },
                cumulativeQuantity: x.cumulativeQuantity,
                netCharges: x.netCharges,
                daysPendingLongTerm: x.daysPendingLongTerm,
                assetType: x.assetType,
                scripIdentifier: x.scripIdentifier,
                netValue: x.netValue,
            };
        });
    }
};
